// extracted by mini-css-extract-plugin
module.exports = {"cardsColumn":"styles_cardsColumn__aV6Di"};